<template>
  <div>
    <v-card
    class="mx-auto"
    height="100vh"
    width="100vw"
  >
    <v-navigation-drawer
      class="green accent-4"
      dark
      permanent
      app
    >
      <v-list>
        <v-list-item
          v-for="item in route"
          :key="item.title"
          link
          :to="item.to"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
        </div>
      </template>
    </v-navigation-drawer>

    <v-row class="ma-5" no-gutters>
       <v-col cols="3">
        
       </v-col>
       <v-col cols="9">
          <p class="text-h5">Online Payments</p>
        <p>if you wish to enable payment for your order, you can securely connect  your banking information to zaastry using of one our supported gateway</p>
        <span class="mb-3"></span>
        <p class="text-caption font-weight-bold">Currency</p>
        <v-select
          :items="currency"
          label="Currency"
          outlined
          dense
        ></v-select>
        <span class="mb-4"></span>
        <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Device Name
          </th>
          <th class="text-left">
            Device ID
          </th>
          <th class="text-left">
            Status
          </th>
          <th class="text-left">
            Device Code
          </th>
          <th class="text-left">
            
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in devices"
          :key="item.name"
        >
          <td>{{ item.name }}</td>
          <td>{{ item.deviceId }}</td>
          <td>{{ item.status }}</td>
          <td>{{item.code}}</td>
          <td>
            <v-btn style="text-transform:none" class="green" x-small  dark>
              View
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
       </v-col>
     </v-row>
  </v-card>
     
  </div>
</template>

<script>
import axios from 'axios'
export default {
data(){
  return {
    currency:['USD','CAD'],
    devices:[],
    route:[
      {name:"Home",icon:"mdi-home",to:"/"},
      {name:"Items",icon:"mdi-shopping-outline",to:"/terminalpos"},
      {name:"Devices",icon:"mdi-devices",to:"/terminalpos/devices"},
    ]
  }
},
mounted(){
  axios.get('https://zaastry-node.herokuapp.com/devices').then(res=>{
    console.log(res.data)
    this.devices=res.data
    localStorage.setitem("devices",JSON.stringify(res.data))
  })
}
}
</script>

<style>

</style>